import http from './httpRequest.js'

export function getMessages(data) {
	return http({
		url: '/api/v1/customer/messages',
		method: 'post',
		data: data
	})
}

export function getMessagesBatch(sessions) {
	return http({
		url: '/api/v1/customer/messages_batch',
		method: 'post',
		data: { sessions }
	})
}

export function getMessagesPage(data) {
	return http({
		url: '/api/v1/customer/messages_page',
		method: 'post',
		data: data
	})
}

export function sendMessage(data, cancelToken) {
	return http({
		url: '/api/v1/customer/send_message4',
		method: 'post',
		data: data,
		cancelToken: cancelToken
	})
}

export function getGroupAccounts(conversationID) {
	return http({
		url: '/api/v1/customer/group_accounts',
		method: 'get',
		params: { conversation_id: conversationID }
	})
}

export function setGroupAccount(data) {
	return http({
		url: '/api/v1/customer/group_account',
		method: 'put',
		data: data
	})
}

export function updateMessageStatus(data) {
	return http({
		url: '/api/v1/customer/message_status',
		method: 'post',
		data: data
	})
}

export function deleteFailedMessage(data) {
	return http({
		url: '/api/v1/customer/message',
		method: 'delete',
		data: data
	})
}
